export type NodeConnectivityStatus = 'healthy' | 'warning' | 'error' | 'unknown';

export const HOST_HEALTH_STATUS = {
  healthy: 'healthy',
  error: 'error',
  unknown: 'unknown',
  warning: 'warning',
};
